<template>
  <div class="container">
    <v-card>
      <v-alert v-model="momopay_flooz_alert" dismissible color="warning">
        <span class="mb-3 font-weight-bold" style="pointer:cursor;">NOTIFICATION NON RECUE<br /></span>
        Les notifications de paiement peuvent prendre 5 à 15 secondes avant de s'afficher sur votre telephone <br>
        donc veuillez patienter jusqu'à 15 secondes et si vous ne recevez toujours pas de notification, <br>
        <span class="font-weight-bold" style="font-size: 2em;">tapez *155*2*4# </span>pour valider la transaction
      </v-alert>
      <v-card-text>
        <v-layout row wrap justify-space-around>
          <v-flex xs12 md5>
            <div class="exchange-section">

              <div class="mt-2 verification-section">
                <v-btn v-if="account_status !== 'verified'" color="red" @click="verify_identity">verifier mon
                  identité</v-btn>
              </div>


              <div class="guide-deposit">
                <Guide_dialog />
                <v-btn class="" flat router href="/dashboard/funds" color="success">Faire un depot</v-btn>
              </div>
              <p class="mt-3 mb-0">DONNEZ</p>
              <div class="give-box mx-3">
                <vs-row>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="5">
                    <div class="coin-box" @click="handle_give_box">
                      <img width="30" class="pl-1" height="30" :src="selected_give.img" :alt="selected_give.title">
                      {{ selected_give.title || "choisir" }}
                      <i class="fas fa-chevron-down ml-1"></i>
                    </div>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="5">
                    <input type="number" v-model="give_amount" class="input_data" @focus="handle_give_focus">
                  </vs-col>

                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="2">
                    <p class="pt-2">{{ selected_give.symbol }} </p>
                  </vs-col>
                </vs-row>

              </div>

              <p v-if="selected_give.type == 'HIROPAY'">solde disponible : <span style="cursor:pointer;"
                  class="success--text"
                  @click="give_amount = parseInt(user[`${selected_give.name}Balance`] * Math.pow(10, selected_give.decimal)) / Math.pow(10, selected_give.decimal); calculate_receive_amount()">{{
                    parseInt(user[`${selected_give.name}Balance`] * Math.pow(10, selected_give.decimal)) / Math.pow(10,
                      selected_give.decimal) }}</span></p>
              <div style="display: flex; justify-content: space-evenly;"
                v-if="selected_give.fee > 0 && give_amount > 0">
                <div class="caption" style=" "> frais dépot : {{ Math.floor(selected_give.fee * 100 * 10) / 10 }}%</div>
                <div class="caption" style=""> total : {{ Number(give_amount) + selected_give.fee * Number(give_amount)
                }}
                </div>
              </div>

              <p class="mt-3 mb-0">RECEVEZ</p>
              <div class="give-box mx-3">
                <vs-row>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="5">
                    <div class="coin-box" @click="handle_receive_box">
                      <img width="30" class="pl-1" height="30" :src="selected_receive.img" alt="">
                      {{ selected_receive.title || "choisir" }}
                      <i class="fas fa-chevron-down ml-1"></i>
                    </div>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="5" height="">
                    <input class="input_data" v-model="receive_amount" type="number" @focus="handle_receive_focus">
                  </vs-col>

                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="2">
                    <p class="pt-2">{{ selected_receive.symbol }}</p>
                  </vs-col>
                </vs-row>

              </div>

              <p class="caption" v-if="selected_receive.symbol !== 'CFA'">Reserve : <span style="cursor:pointer;"
                  class="success--text">{{ asset_reserve[selected_receive.currency] }}</span></p>
              <p v-if="over_amount && receive_amount > 0" class="red--text ">Montant doit être compris entre
                {{ asset_selected_limit.min }} et {{ asset_selected_limit.max }} {{ selected_receive.currency }} </p>
              <p v-if="over_reserve > 0" class="red--text">Montant doit être inferieur à
                {{ asset_reserve[selected_receive.currency] }} </p>

              <div  v-if="selected_receive.symbol == 'CFA' && !from_funds">
                <v-bottom-sheet v-model="sheet">
                  <template v-slot:activator>
                    <v-btn color="success" dark large>
                      Choisir un moyen de Retrait
                    </v-btn>
                  </template>

                  <v-card class="pt-3">
                    <v-layout row wrap>
                      <v-flex xs12 text-xs-center><span class="font-weight-bold">CHOISIR UN MOYEN DE
                          RECEPTION</span></v-flex>
                      <v-flex xs6 md3 v-for="country in moyens" :key="country.country">
                        <v-card-title primary-title>
                          <span class="font-weight-bold">{{ country.country.toUpperCase() }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-list>
                            <v-list-tile v-for="item in country.items" :key="item.title"
                              @click="handle_sheet(item.title)">
                              <v-list-tile-avatar>
                                <v-avatar size="32px" tile>
                                  <img :src="item.img" :alt="item.title">
                                </v-avatar>
                              </v-list-tile-avatar>
                              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-card-text>
                        <v-divider></v-divider>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-bottom-sheet>

                <div>
                  Moyen choisi : <span class="red--text"> {{ moyen }}</span>
                </div>
              </div>

              <div class="my-2" v-if="selected_receive.symbol == 'CFA' && from_funds">
                <v-bottom-sheet v-model="sheet">
                  <template v-slot:activator>
                    <v-btn color="success" dark large>
                      Choisir un moyen de Retrait
                    </v-btn>
                  </template>

                  <v-card class="pt-3">
                    <v-layout row wrap>

                      <v-flex xs12 text-xs-center><span class="font-weight-bold">CHOISIR UN MOYEN DE
                          RECEPTION</span></v-flex>
                      <v-flex xs6 md3 v-for="country in sub_moyens" :key="country.country">
                        <v-card-title primary-title>
                          <span class="font-weight-bold">{{ country.country.toUpperCase() }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-list>
                            <v-list-tile v-for="item in country.items" :key="item.title"
                              @click="handle_sheet(item.title)">
                              <v-list-tile-avatar>
                                <v-avatar size="32px" tile>
                                  <img :src="item.img" :alt="item.title">
                                </v-avatar>
                              </v-list-tile-avatar>
                              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-card-text>
                        <v-divider></v-divider>
                      </v-flex>

                    </v-layout>
                  </v-card>
                </v-bottom-sheet>

                <div>
                  Moyen choisi : <span class="red--text"> {{ moyen }}</span>
                </div>
              </div>

              <div class="mb-3">
                <div class="wallet" v-if="selected_receive.symbol !== 'CFA'">
                  <p class="mt-3">Wallet {{ selected_receive.title }} </p>
                  <v-text-field name="walllet" :label="`Wallet ${selected_receive.title}`" id="id"
                    v-model="receive_wallet"></v-text-field>
                  <p v-if="!valid_wallet && receive_wallet.length > 2" class="red--text">wallet de reception invalide
                  </p>
                  <p v-if="valid_wallet && receive_wallet.length > 5" class="green--text">wallet valide</p>
                  <p v-if="require_wallet" class="red--text">wallet de reception obligatoire</p>
                </div>

                <div class="wallet" v-if="selected_receive.symbol == 'CFA'">
                  <p class="mt-3">Numero {{ moyen }} </p>
                  <input v-model="numero" class="input_wallet px-1" type="number"
                    style="height:40px; font-size:1.5em; ">
                  <p class="red--text subheader" v-if="!valid_momo_number && numero.length >= 1">veuillez saisir
                    juste le
                    numero à {{ expectedNumberLength }} chiffres sans
                    indicatif </p>
                  <p v-if="require_wallet" class="red--text">wallet de reception obligatoire</p>
                </div>

              </div>
              <div class="footer-dialog my-4">
                <vs-button size="xl" block @click="check_data">
                  Proceder à l'échange
                </vs-button>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 md6>
            <div class="mt-5">
              <v-flex xs12 text-xs-center class="#bbdefb blue lighten-4 mt-1 pa-2">
                <h3>Dernières transactions</h3>
                <p>cliquer sur chaque historique pour plus de details</p>
              </v-flex>

              <RecentTransactions />
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-dialog v-model="show_pm_alert" max-width="900" persistent :overlay="false" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title class="font-weight-bold">

        </v-card-title>
        <v-card-text>
          <div style="font-family: Arial, sans-serif; line-height: 1.6; background-color: #f4f4f4; padding: 20px;">
            <div
              style="background-color: white; padding: 20px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); max-width: 700px; margin: auto;">
              <h2 style="color: #e74c3c; text-align: center;">Notification Importante</h2>
              <h2 style="color: #e74c3c; text-align: center;">PERFECTMONEY NON DISPONIBLE DANS CERTAINS PAYS</h2>
              <p style="color: black;">
                Nous tenons à vous informer que Perfect Money ne fournit plus ses services aux clients basés dans
                certains
                pays en raison de récents changements réglementaires dans la région.
              </p>
              <p style="color: black;">
                En conséquence, veuillez vérifier si votre pays est éligible et si votre compte peut recevoir les
                transactions avant d'acheter les PM sur HIROPAY.
              </p>

              <p style="color: #e74c3c; font-weight: bold;">
                lors de la creation de votre compte perfectmoney si vous navez pa choisi l'un de ces pays eligibles, ne
                faites pas le paiement, car votre compte ne pourra pas recevoir les PM. Dans ce cas, veuillez choisir
                une
                autre monnaie ou créer un compte en sélectionnant l'un des pays éligibles. <br> <br>
              </p>
            </div>
          </div>
          <v-flex xs12 text-xs-center>
            <v-btn color="primary" @click="show_pm_alert = false">JE COMPRENDS, FERMER</v-btn>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_give_receive" width="800" origin="bottom center" :fullscreen="this.$device.mobile">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span>{{ give ? " VOUS DONNEZ" : "VOUS RECEVEZ" }} </span>
        </v-card-title>

        <v-card-text>

          <div class="giv_back_box mx-3" v-if="give">

            <p class="pt-2 font-weight-bold">PAIEMENT DIRECT</p>

            <div>
              <v-flex xs12 text-xs-center>
                <p class="pt-2 caption">cryptomonnaies et PM</p>
              </v-flex>

              <vs-row>
                <vs-col class="px-1 py-1" v-for="item in external_assets" :key="item.id" vs-type="flex"
                  vs-justify="center" vs-align="center" :w="external_assets.indexOf(item) < 2 ? 6 : 4">
                  <div class="coin_back_box" @click="handle_selected_give(item)" style="height:60px;">
                    <img width="30" class="mr-1" height="30" :src="item.img" alt="">
                    {{ item.title }}
                  </div>
                </vs-col>
              </vs-row>
            </div>

            <div class="my-3">
              <v-flex xs12 text-xs-center>
                <p class="pt-2 caption">mobile money</p>
              </v-flex>
              <vs-row>
                <vs-col class="px-1 py-1" v-for="item in direct_moyens" :key="item.title" vs-type="flex"
                  vs-justify="center" vs-align="center" w="4">

                  <div class="coin_back_box" @click="handle_selected_give(item)" style="height:60px;">
                    <img width="18" class="mr-1" height="30" :src="item.img" alt="">
                    {{ item.title }}
                  </div>
                </vs-col>
              </vs-row>
            </div>



            <div>
              <p class="pt-2 font-weight-bold">SOLDE HIROPAY</p>
              <vs-row>
                <vs-col class="px-1 py-1" v-for="item in assets" :key="item.id" vs-type="flex" vs-justify="center"
                  vs-align="center" w="4">
                  <div v-if="item.type == 'HIROPAY'" class="coin_back_box" @click="handle_selected_give(item)"
                    style="height:60px;">
                    <img width="24" class="mr-1" height="24" :src="item.img" alt="">
                    {{ item.title }}
                  </div>
                </vs-col>
              </vs-row>
            </div>

          </div>
          <!-- <p>receive items</p> -->

          <div class="giv_back_box mx-3" v-if="!give">
            <vs-row>
              <vs-col class="px-1 py-1" v-for="item in assets2" :key="item.title" vs-type="flex" vs-justify="center"
                vs-align="center" w="6">

                <v-card-text>
                  <div class="coin_back_box" @click="handle_selected_receive(item)" style="height:80px;">
                    <img width="24" class="mr-1" height="24" :src="item.img" alt="">
                    {{ item.title }}
                  </div>
                </v-card-text>

              </vs-col>
            </vs-row>

          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog_give_receive = false">
            fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <vs-dialog blur prevent-close v-model="usdt_small_amount_dialog">
      <div style="text-align: center;" class="pt-4">
        <p>
          Transaction inférieur a 50 USDT TRC20, frais d'envoi de 1 USDT ({{ }} )<br>
          si vous êtes d'accord cliquez sur continuer sinon <br>saisissez un montant superieur a 50 USDT
        </p>
        <v-btn color="success" @click="confirm_dialog = true; usdt_small_amount_dialog = false">continuer</v-btn><v-btn
          flat color="secondary" @click="usdt_small_amount_dialog = false">annuler</v-btn>
      </div>
    </vs-dialog>

    <div class="confirm_dialo_vuesax">
      <vs-dialog blur prevent-close v-model="confirm_dialog">
        <template #header>
          <h4 class="not-margin">Confirmation</h4>
        </template>
        <div class="con-form">
          <div>
            <vs-table striped>
              <template #thead>
                <vs-tr>
                  <vs-th> Designation </vs-th>
                  <vs-th> valeur </vs-th>
                </vs-tr>
              </template>
              <template #tbody>
                <vs-tr>
                  <vs-td>VOUS DONNEZ </vs-td>
                  <vs-td>
                    <span class="font-weight-bold">{{ give_amount }}</span> {{ selected_give.symbol }}
                    {{ selected_give.network }}
                  </vs-td>
                </vs-tr>
                <vs-tr style="font-size: 1.3em">
                  <vs-td>VOUS RECEVEZ </vs-td>
                  <vs-td>
                    <span class="font-weight-bold">{{ usdt_less_than_fifty ? receive_amount - 1 : receive_amount
                    }}</span>
                    {{ selected_receive.symbol }} {{ network }}
                  </vs-td>
                </vs-tr>
                <vs-tr style="font-size: 1.3em" v-if="selected_receive.symbol !== 'CFA'">
                  <vs-td>wallet de reception </vs-td>
                  <vs-td>
                    {{ receive_wallet }}
                  </vs-td>
                </vs-tr>

                <vs-tr style="font-size: 1.3em" v-if="selected_receive.symbol == 'CFA'">
                  <vs-td> MOYEN DE PAIEMENT</vs-td>
                  <vs-td class="red--text font-weight-bold">
                    {{ moyen }}
                  </vs-td>
                </vs-tr>

                <vs-tr v-if="selected_receive.symbol == 'CFA'">
                  <vs-td> Numero</vs-td>
                  <vs-td class="font-weight-bold red--text" style="font-size: 1.8em">
                    {{ numero }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <p v-if="selected_receive.symbol == 'CFA'" class="caption red--text" style="text-align:center">veuillez
              verifier
              à nouveau votre numero de reception avant de valider votre opération, si vous vous trompez de numero nous
              ne
              serons pas en mesure de vous aider à recouvrer vos fonds</p>

            <div class="confirm_code" v-if="selected_give.type == 'HIROPAY' && selected_give.name !== 'momo'">
              <vs-tr v-if="deposit_address.length < 10">
                <vs-th>CODE {{ user.auth2fa.google ? '2FA' : "PIN" }}</vs-th>
                <vs-th><vs-input type="number" v-model="pin2faCode"
                    :placeholder="user.auth2fa.google ? 'CODE 2FA' : 'CODE PIN'" style="font-size: 1.4em" />
                </vs-th>
              </vs-tr>
            </div>

            <div v-if="this.selected_give.type == 'external' && !show_qr" style="width: 50%; margin: 0 auto;">
              <v-btn class="my-3 py-4" color="primary" large @click="generate();">Generer l'adresse</v-btn>
            </div>

            <div class="pay_external" v-if="selected_give.name == 'direct_asset'">
              <v-flex xs12 text-xs-center>
                <div v-if="selected_give.currency == 'PM'">
                  <Pay_pm :amount=give_amount :data=external_pm_data />
                </div>
              </v-flex>
            </div>

            <div class="mobile_money" v-if="selected_give.name == 'momo'">
              <vs-tr v-if="!hiropay_pay_fee">
                <vs-th>
                  <p class="caption">frais depot: {{ Math.floor(selected_give.fee * 100 * 10) / 10 }}%</p>
                </vs-th>
                <vs-th class="caption">total : <span>{{ (Number(give_amount) +
                  selected_give.fee * Number(give_amount)).toFixed(0) }}</span> </vs-th>
              </vs-tr>
              <vs-tr>
                <vs-th>Vous payez par</vs-th>
                <vs-th><img class="mx-3" width="35" :src="selected_give.img" :alt="selected_give.title"><span>{{
                  selected_give.title }}</span> </vs-th>
              </vs-tr>

              <vs-tr>
                <vs-th>Numero de Facturation</vs-th>
                <vs-th><vs-input type="number" v-model="phone_number" placeholder="Numero de facturation"
                    style="font-size: 2em" /> </vs-th>
              </vs-tr>

              <div v-if="selected_give.title == 'OM BURKINA' && processors.bf.buyProcessor == 'intouch'">
                <vs-tr>
                  <vs-th>code OTP</vs-th>
                  <vs-th><vs-input type="number" v-model="otp" placeholder="saisir votre code otp"
                      style="font-size: 1.5em" /> </vs-th>
                </vs-tr>
                <p class="caption">Obtenez votre code de paiement OTP depuis votre mobile <br> en tapant <span
                    style="font-size: 1.4em" class="red--text">*144*4*6*{{ hiropay_pay_fee ? give_amount :
                      ((1 + selected_give.fee) * give_amount).toFixed(0) }}#</span> </p>
              </div>

              <div v-if="selected_give.title == 'OM CIV' && processors.ci.buyProcessor == 'intouch'">
                <vs-tr>
                  <vs-th>code OTP</vs-th>
                  <vs-th><vs-input type="number" v-model="otp" placeholder="taper #144*82# sur votre telephone "
                      style="font-size: 1.5em" /> </vs-th>
                </vs-tr>
                <p class="caption">Obtenez votre code de paiement OTP depuis votre mobile <br> en tapant <span
                    style="font-size: 1.4em" class="red--text">#144*82#</span> </p>
              </div>
              <p class="red--text subheader" v-if="!valid_momo_number && phone_number.length >= 1">veuillez saisir
                juste le
                numero à {{ expectedNumberLength }} chiffres sans
                indicatif </p>
              <p class="green--text subheader" v-if="valid_momo_number">Numero valide</p>
              <v-flex xs12 text-xs-center>
                <v-btn large @click="handle_momopay" color="success">PAYER</v-btn>
              </v-flex>
            </div>
          </div>
        </div>

        <div v-if="show_qr" style="text-align:center;">
          <v-flex text-xs-center xs12>
            <p class="caption red--text"> Envoyez uniquement {{ selected_give.symbol }} {{ selected_give.network }} à
              cette
              adresse</p>
            <span>MONTANT: </span>
            <h3 style="display:inline-block;">{{ give_amount }} {{ selected_give.symbol }} {{ selected_give.network }}
            </h3>
            <br>
            <div @click="copy(deposit_address)" style="cursor:pointer;">
              <qrcode-vue class="mt-3" :value="deposit_address" size="170" level="H"></qrcode-vue>
            </div>
            <br />
            <p @click="copy(deposit_address)" style="cursor:pointer;">{{ deposit_address }}</p>
            <p class="caption green--text" v-if="copied" style="line-height:30%;">Adresse
              {{ this.selected_give.currency }}
              copié avec success!</p>
            <p class="caption" v-if="!copied" @click="copy(deposit_address)" style="cursor:pointer;line-height:50%;">
              cliquer
              sur l'adresse ou le QR pour copier</p>
            <p class="caption" v-if="!copied"> Cette operation est automatique et ne necessite <br> aucune action apres
              le
              paiement</p>
          </v-flex>
        </div>

        <template #footer>
          <div v-if="!show_qr" style=" width:100px;margin: 0 auto;">
            <vs-button border @click="go_back">
              Retour
            </vs-button>
          </div>
        </template>
      </vs-dialog>
    </div>



    <v-dialog v-model="paymentInstructionAlert" fullscreen persistent :overlay="false" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title class="font-weight-bold">
        </v-card-title>
        <v-card-text>
          <v-flex xs12 text-xs-center>
            <p class="green--text body-2 font-weight-bold">Finalisez votre votre paiement en suivant les instructions
              suivantes</p>
            <div v-if="paymentInstructionAlert" class="red--text body-2 font-weight-bold">
              <v-alert v-model="paymentInstructionAlert" color="success">
                Pour finaliser votre paiement veuillez taper: <br> <span class="font-weight-bold"
                  style="font-size: 2em;">{{
                    selected_give.title == "OM MALI" ? '#144#code secret orange money#' : '*555*6#' }}</span><br>
                si vous ne le faites pas votre paiement ne sera pas validé
              </v-alert>
            </div>

            <!-- <p class="caption red--text" v-if="moyen=='Flooz'">Veillez choisir Transfert MARCHANT dans les options d'envoi flooz</p> -->
          </v-flex>
          <v-flex xs12 text-xs-center>
            <v-btn color="primary" @click="paymentInstructionAlert = false">FERMER</v-btn>
          </v-flex>
        </v-card-text>
      </v-card>

    </v-dialog>

  </div>
</template>

<script>

import axios from 'axios'
import db from '../db'
import firebase from '../fb'
import { mapGetters, mapActions } from 'vuex'
const RecentTransactions = () => import("../components/funds/Recent_transactions.vue");
const Guide_dialog = () => import("../components/instant_change/Guid_dialog.vue");
const Pay_pm = () => import("../components/instant_change/Pay_pm.vue");
const copy = require('clipboard-copy')

export default {
  components: {
    RecentTransactions,
    Guide_dialog,
    Pay_pm
  },
  props: {
    activate_instant_dialog: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      processors: {},
      paymentMethods:{},
      unsubscribeInstantData: null,
      //direct_moyens: [],
      show_pm_alert: false,
      trade_commission: 15,
      paygate_fee: 0.04,
      momopay_flooz_alert: false,
      expectedNumberLength: 0,
      paymentInstructionAlert: false,
      otp: '',
      sheet: true,
      phone_number: '',
      dialog_give_receive: false,
      btc_price: 0,
      bnb_price: 0,
      deposit_address: '',
      show_qr: false,
      shib_price: 0,
      active: false,
      back: false,
      network: '',
      copied: false,
      asset_reserve: {},
      minimum_reserve: { BTC: 0.005, USDT: 90, PM: 100, SHIB: 2000000, BNB: 0.1 },
      over_reserve: false,
      numero: '',
      moyen: '',
      value: '',
      total_dollar: null,
      currency_price_in_dollar: null,
      require_network: true,
      require_wallet: '',
      valid_wallet: false,
      asset_selected_limit: {},
      pin2faCode: '',
      over_amount: false,
      pin: '',
      give: false,
      confirm_dialog: false,
      receive_wallet: '',
      give_amount: '',
      receive_amount: '',
      give_focus: null,
      receive_focus: null,
      give_assets: [],
      receive_assets: [],
      selected_give: '',
      selected_receive: '',
      pass: process.env.VUE_APP_SECRET,
      member_status: null,

      valid_momo_number: false,
      fees_select: ['HIROPAY', 'MOI MEME'],
      usdt_small_amount_dialog: false,

      assets: [
        { id: 0, title: "CFA", img: "/img/logo.png", symbol: 'CFA', decimal: 0, type: 'HIROPAY', currency: 'HRP CFA', name: 'cfa' },
        { id: 1, title: "USDT TRC20", img: "/img/usdt.svg", symbol: 'USDT', decimal: 2, currency: 'USDT', type: 'external', network: 'TRC20' },
        { id: 2, title: "USDT BEP20", img: "/img/usdt.svg", symbol: 'USDT', decimal: 2, currency: 'USDT', type: 'external', network: 'BEP20' },
        { id: 3, title: "TRON", img: "/img/trx.svg", symbol: 'TRX', decimal: 2, currency: 'TRX', type: 'external',name: 'trx'},
        { id: 4, title: "BTC", img: "/img/bitcoin.svg", symbol: 'BTC', decimal: 6, type: 'external', currency: 'BTC', name: 'btc' },
        { id: 5, title: "BNB BEP20", img: "/img/bnb.svg", symbol: 'BNB', decimal: 4, currency: 'BNB', type: 'external', network: 'BSC' },
        { id: 6 , title: "PAYEER USD", img: "/img/payeer.png", symbol: 'PAYEER', decimal: 2, currency: 'PAYEER', type: 'external' },
        //{ id: 5, title: "TON", img: "/img/ton.svg", symbol:'TON', decimal:4, currency:'TON',type:'external', network:'TON'},
        //{ id: 6, title: "DOGE", img: "/img/doge.svg", symbol:'DOGE', decimal:2,type:'external', currency:'DOGE'},

      ],

      adminAssets: [
        { id: 7, title: "BITCOIN", img: "/img/bitcoin.svg", symbol: 'BTC', decimal: 6, currency: 'BTC', type: 'HIROPAY', name: 'btc' }
        // { id: 8, title: "USDT", img: "/img/usdt.svg", symbol: 'USDT', decimal: 2, currency: 'USDT', type: 'HIROPAY', name: 'usdt' },
      ],

      assets2: [

        { id: 0, title: "BITCOIN", img: "/img/bitcoin.svg", symbol: 'BTC', decimal: 6, currency: 'BTC' },
        { id: 1, title: "USDT TRC20", img: "/img/usdt.svg", symbol: 'USDT', decimal: 2, currency: 'USDT', network: 'TRC20' },
        { id: 2, title: "USDT BEP20", img: "/img/usdt.svg", symbol: 'USDT', decimal: 2, currency: 'USDT', network: 'BSC(BEP20)' },
        { id: 3, title: "BNB BEP20", img: "/img/bnb.svg", symbol: 'BNB', decimal: 4, currency: 'BNB', network: 'BSC(BEP20)' },
        { id: 4, title: "SHIBA BSC", img: "/img/shib.svg", symbol: 'SHIB', decimal: 0, currency: 'SHIB', network: 'BSC(BEP20)' },
        { id: 5, title: "TRON", img: "/img/trx.svg", symbol: 'TRX', decimal: 2, currency: 'TRX' },
        { id: 6, title: "SOL", img: "/img/sol.png", symbol: 'SOL', decimal: 4, currency: 'SOL', },
        { id: 7, title: "PAYEER USD", img: "/img/payeer.png", symbol: 'PAYEER', decimal: 2, currency: 'PAYEER' },
        // { id: 7, title: "ADV USD", img: "/img/adv.png", symbol: 'USD', decimal: 2, currency: 'ADV', network : 'USD' },
      ],
      // direct_moyens: [
      //   { title: 'MOOV TOGO', img: '/img/moov.jpg', name: 'momo', fee: 0.02, country: 'tg' },
      //   { title: 'TMONEY TOGO', img: '/img/tmoney.png', name: 'momo', fee: 0.02, country: 'tg' },
      //   { title: 'MTN CIV', img: '/img/mtn.svg', name: 'momo', fee: 0.02, country: 'ci' },
      //   { title: 'OM CIV', img: '/img/orange.svg', name: 'momo', fee: 0.02, country: 'ci' },
      //   { title: 'MOOV CIV', img: '/img/moov.jpg', name: 'momo', fee: 0.02, country: 'ci' },
      //   { title: 'WAVE CIV', img: '/img/wave.png', name: 'momo', fee: 0.02, country: 'ci' },

      //   { title: 'MTN BENIN', img: '/img/mtn.svg', name: 'momo', fee: 0.02, country: 'bj' },
      //   { title: 'MOOV BENIN', img: '/img/moov.jpg', name: 'momo', fee: 0.02, country: 'bj' },
      //   { title: 'OM SENEGAL', img: '/img/orange.svg', name: 'momo', fee: 0.02, country: 'sn' },
      //   { title: 'WAVE SENEGAL', img: '/img/wave.png', name: 'momo', fee: 0.02, country: 'sn' },

      //   { title: 'OM BURKINA', img: '/img/orange.svg', name: 'momo', fee: 0.02, country: 'bf' },
      //   { title: 'MOOV BURKINA', img: '/img/moov.jpg', name: 'momo', fee: 0.02, country: 'bf' },

      //   { title: 'OM MALI', img: '/img/orange.svg', name: 'momo', fee: 0, country: 'ml' },
      //   { title: 'MOOV MALI', img: '/img/moov.jpg', name: 'momo', fee: 0, country: 'ml' },
      // ],
      totp_validate: process.env.VUE_APP_TOTP_VALIDATE,
      totp_secret: process.env.VUE_APP_TOTP_SECRET,
      sub_moyens: [],
      from_funds: false,
    }
  },

  computed: {
    external_pm_data() {
      let data = {
        give: this.selected_give.currency,
        receive: this.selected_receive.currency,
        give_amount: Number(this.give_amount),
        receive_amount: Number(this.receive_amount),
        numero: this.numero,
        address: this.numero,
        moyen: this.moyen,
        sell_price: this.currencies.sell["pm"],
        instant_type: "external",
        type: "vente",
        currency: this.moyen,
        devise: "cfa",
        amount: Number(this.receive_amount)
      }
      return data
    },

    userCountry() {
      let country = this.user.country.toLowerCase();

      // Define the mapping of country codes to their respective values
      // The values are arrays of possible matches for each country code
      const countryMap = {
        "ci": ["ci", "civ", "cote", "ivoire"],
        "tg": ["tg", "togo"],
        "ml": ["mali", "ml"],
        "bf": ["bf", "burkina", "faso"],
        "bj": ["bj", "benin"],
        "ng": ["ng", "niger"],
        "sn": ["sn", "senegal"],
        "cm": ["cm", "cameroun", "cameroon"],
        "gb": ["gb", "gabon"],
        "cd": ["cd", "rdc"]
      };

      for (const [key, values] of Object.entries(countryMap)) {
        if (values.some(element => element.startsWith(country) || element.includes(country))) {
          return key;
        }
      }
      return null; // If no match is found
    },

    usdt_less_than_fifty() {
      return this.selected_receive.currency == 'USDT' && this.selected_receive.network == 'TRC20' && this.receive_amount < 50
    },

    coinbase_assets() {
      let items = ['SHIB', 'BTC', 'ETH', 'DOGE',]
      return items.indexOf(this.selected_receive.symbol) >= 0
    },

    external_assets() {
      return this.assets.filter(obj => obj.type == 'external')
    },
    // moyens() {
    //   return this.instant_data.hiropay.moyens.map(el => {
    //     let country = el.country
    //     country == 'civ' ? el.country = "Cote d'ivoire" : ''
    //     let items = el.items
    //     el.items = items.filter(item => item.active == true)
    //     return el
    //   })
    // },
     direct_moyens() {
      let data =   this.paymentMethods || {}
      console.log(data);
      
      const countryFeeMap = {
        ml:0.01,
        tg: 0.02,
        ci: 0.02,
        bj: 0.02,
        sn: 0.02,
        bf: 0.02,
      };

      const methodConfig = {
        moov: {
          img: "/img/moov.jpg",
          titles: {
            tg: "MOOV TOGO",
            ci: "MOOV CIV",
            bf: "MOOV BURKINA",
            ml: "MOOV MALI",
            bj: "MOOV BENIN"
          }
        },
        tmoney: {
          img: "/img/tmoney.png",
          titles: {
            tg: "TMONEY TOGO"
          }
        },
        mtn: {
          img: "/img/mtn.svg",
          titles: {
            ci: "MTN CIV",
            bj: "MTN BENIN"
          }
        },
        orange: {
          img: "/img/orange.svg",
          titles: {
            ci: "OM CIV",
            sn: "OM SENEGAL",
            bf: "OM BURKINA",
            ml: "OM MALI"
          }
        },
        wave: {
          img: "/img/wave.png",
          titles: {
            ci: "WAVE CIV",
            sn: "WAVE SENEGAL"
          }
        }
      };

      const direct_moyens = [];
      
      for (const [countryCode, { buy }] of Object.entries(data)) {
         console.log(countryCode,countryCode == 'ml',  countryFeeMap[countryCode]);
        
        const fee = countryFeeMap[countryCode] !== undefined ? countryFeeMap[countryCode] : 0.03
        console.log(fee);
        
        for (const [method, active] of Object.entries(buy)) {
          if (!active || !methodConfig[method]) continue;

          const config = methodConfig[method];
          const title = config.titles[countryCode] || `${method.toUpperCase()} ${countryCode.toUpperCase()}`;
          const img = config.img;

          direct_moyens.push({
            title,
            img,
            name: "momo",
            fee,
            country: countryCode
          });
        }
      }

      const preferredOrder = ["tg", "ci", "ml", "bf", "bj"];
      direct_moyens.sort((a, b) => {
    const indexA = preferredOrder.indexOf(a.country);
      const indexB = preferredOrder.indexOf(b.country);

      // Put unknown countries (index -1) after the ordered ones
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
    });
      return direct_moyens;

    },

    moyens() {
      let data =    this.paymentMethods || {}
      const countryNames = {
        tg: "TOGO",
        bf: "BURKINA FASO",
        ci: "COTE D'IVOIRE",
        ml: "MALI",
        sn: "SENEGAL",
        cm: "CAMEROUN",
        bj: "BENIN",
        ne: "NIGER",
        cd: "RDC",
        ga: "GABON"
      };

      const methodInfo = {
        moov: { title: { tg: "Flooz-TOGO", ci: "MOOV CI", bf: "MOOV BURKINA", ml: "MOOV MALI", bj: "MOOV BENIN", ga: "MOOV GABON" }, img: "/img/moov.jpg" },
        tmoney: { title: { tg: "Tmoney" }, img: "/img/tmoney.png" },
        orange: { title: { ci: "OM CI", bf: "OM BURKINA", ml: "OM MALI", sn: "OM SENEGAL", cm: "OM CAM", ne: "OM NIGER", cd: "OM RDC" }, img: "/img/orange.svg" },
        mtn: { title: { ci: "MTN CI", bj: "Mtn Benin", cm: "MTN CAM" }, img: "/img/mtn.svg" },
        wave: { title: { ci: "Wave CI", sn: "Wave SEN" }, img: "/img/wave.png" },
        airtel: { title: { ne: "Airtel NIGER", cd: "Airtel RDC", ga: "Airtel GABON" }, img: "/img/airtel.png" },
        mpesa: { title: { cd: "Mpesa RDC" }, img: "/img/mpesa.png" }
      };

      const preferredOrder = ["tg", "ci", "ml", "bf", "bj"];

      const result = Object.entries(data).map(([countryCode, { sell }]) => {
        const items = Object.entries(sell)
          .filter(([_, active]) => active) // Only include methods that are true
          .map(([method, active]) => {
            const info = methodInfo[method];
            const title = (info && info.title && info.title[countryCode]) || method.toUpperCase();
            const img = (info && info.img) || "/img/default.png";

            return {
              active,
              title,
              img
            };
          });
        return {
          code: countryCode,
          country: countryNames[countryCode] || countryCode.toUpperCase(),
          items
        };
      }).filter(entry => entry.items.length > 0)
        .sort((a, b) => {
          const indexA = preferredOrder.indexOf(a.code);
          const indexB = preferredOrder.indexOf(b.code);
          // Countries in preferredOrder come first, and in order. Others come after.
          if (indexA === -1 && indexB === -1) return a.country.localeCompare(b.country);
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        })
        .map(({ code, ...rest }) => rest);
      return result
    },
    solde_cfa() {
      return this.selected_give.currency == 'HRP CFA'
    },
    currencies() {
      let obj = {}
      this.instant.forEach(element => {
        obj[`${element.id}`] = element
      });
      return obj
    },

    instant_data() {
      let obj = {}
      this.instant.forEach(element => {
        obj[`${element.id}`] = element
      });
      return obj
    },

    hiropay_pay_fee() {
      return this.instant_data.hiropay.hiropay_pay_fee
    },

    extra_cameroun() {
      return this.instant_data.hiropay.extra_cameroun
    },

    ...mapGetters({
      instant: "authfb/instant"
    }),
    ...mapGetters({
      user: "authfb/user"
    }),

    ...mapGetters({
      instant_test: "authfb/instant_test"
    })


  },

  async mounted() {
   this.bind_instant()
   this.bind_perso();
    
    db.collection('processors').onSnapshot((snapshot) => {
      const processorsObject = {};
      // Iterate through the documents
      snapshot.forEach(doc => {
        // Use doc.id as the key and doc.data() as the value
        processorsObject[doc.id] = doc.data();
      });
      this.processors = processorsObject
    })
    
    if (this.user.email == 'dissjacques@gmail.com') {
      this.assets.push({ id: 20, title: "BITCOIN", img: "/img/bitcoin.svg", symbol: 'BTC', decimal: 6, currency: 'BTC', type: 'HIROPAY', name: 'btc' })
      console.log('assets push', this.assets);

    }

    let user = firebase.auth().currentUser
    let member_status = user.displayName
    this.member_status = member_status
    this.give_assets = this.assets;
    this.active = this.activate_instant_dialog
    this.$root.$on('activate_instant_dialog', () => {
      this.active = true;
    })
    this.$root.$on('pay_pm_dialog', () => {
      console.log('hi close dialog');
      this.dialog_give_receive = false
      this.give_amount = 0
      this.receive_amount = 0
      //this.moyen = ''
      this.confirm_dialog = false
      window.location.reload()
    })

    let from_path = this.$router.currentRoute.redirectedFrom

    if (from_path) {
      let currency = from_path.split("/")[2]
      console.log(currency);
      this.from_funds = true

      //this.selected_receive = { id: 0, title: "CFA", img: "/img/cfa.png", symbol: 'CFA', decimal: 0, currency: 'CFA' }
      this.sheet = false
      switch (currency) {
        case 'btc': this.selected_give = { id: 1, title: "BTC", img: "/img/bitcoin.svg", symbol: 'BTC', decimal: 6, type: 'HIROPAY', currency: 'BTC', name: 'btc' }
          break;
        case 'usdt': this.selected_give = { id: 8, title: "USDT", img: "/img/usdt.svg", symbol: 'USDT', decimal: 2, currency: 'USDT', type: 'HIROPAY', name: 'usdt' }
          break;

        default:
          break;
      }
    }

  },

  async updated() {
    console.log(this.direct_moyens);
    
    if (this.sub_moyens.length == 0 && this.from_funds) {
      let instant_test = await this.$store.getters['authfb/instant_test']
      console.log(instant_test);
      this.sub_moyens = instant_test.hiropay.moyens.map(el => {
        let country = el.country
        country == 'civ' ? el.country = "Cote d'ivoire" : ''
        let items = el.items
        el.items = items.filter(item => item.active == true)
        return el
      })
    }
  },
  watch: {
    give_amount(newValue, oldValue) {
      if (this.give_focus) {
        this.fire_calculate()
      }
    },

    phone_number(newValue, oldValue) {
      let payload = { number: newValue, moyen: this.selected_give.title }
      this.valid_phone_number(payload)
    },

    numero(newValue, oldValue) {
      let payload = { number: newValue, moyen: this.moyen }
      this.valid_phone_number(payload)
    },

    pin2faCode(newValue, oldValue) {
      let codeLength = this.user.auth2fa.google ? 6 : 4
      let code = newValue.slice(0, codeLength)
      console.log(code, codeLength);
      if (newValue.length == codeLength) {
        this.validateAuthPinCode()
      }
    },

    pin(newValue, oldValue) {
      if (newValue.length == 4) {
        this.validateAuthPinCode()
      }
    },

    receive_amount(newValue, oldValue) {
      if (this.receive_focus) {
        this.fire_calculate_give()
      }
    },

    receive_wallet(newValue, oldValue) {
      this.valid_address()
    },

    selected_receive(newValue, oldValue) {
      this.selected_receive.network ? this.network = this.selected_receive.network : ''
      this.valid_address()
      this.get_currency_price(this.selected_receive.currency)
    },

    network(newValue, oldValue) {
      this.valid_address()
    },

  },

  created: function () {
    this.fire_calculate = _.debounce(this.calculate_receive_amount, 400);
    this.fire_calculate_give = _.debounce(this.calculate_give_amount, 400);
    this.initializePaymentMethods()
    this.get_currency_price('BTC')

  },
  methods: {
    test() {
      console.log(this.currency);
    },
    async handle_momopay() {
      if (this.valid_momo_number) {
        let currency = this.selected_receive.currency
        let recent_ref = db.collection('recent_transactions').doc()
        let user_id = this.user.id

        let item = currency.toLowerCase()
        let network

        this.selected_receive.network ? network = this.network : network = currency
        let fee = 0

        let id = recent_ref.id

        let give_amount = Number(this.give_amount)

        let real_give_amount
        let momo_fee = this.selected_give.fee
        //let  dollar_price =   this.currencies[`${item}`][`$_${item}`]
        let base_dollar_price = this.currencies[`${item}`][`$_${item}`]

        let userCountry = this.userCountry

        let cameroun_citizen = userCountry == 'cm' ? true : false
        let dollar_price = cameroun_citizen ? base_dollar_price + this.extra_cameroun : base_dollar_price

        console.log(userCountry, 'userCountry');

        let currency_cfa_dollar = dollar_price + momo_fee * dollar_price
        console.log(dollar_price, currency_cfa_dollar);

        if (this.hiropay_pay_fee ) {
          real_give_amount = (1 - momo_fee) * give_amount
        } else {
          give_amount = (1 + momo_fee) * give_amount
          give_amount = give_amount.toFixed(0)
          real_give_amount = give_amount
        }

        let data = {
          amount: Number(this.receive_amount),
          give_amount: Number(give_amount),
          receive_amount: Number(this.receive_amount),
          give: this.selected_give.title,
          receive: this.selected_receive.currency,
          currency,
          currency_price_in_dollar: Number(this.currency_price_in_dollar),
          currency_cfa_dollar,
          total_dollar: Number(this.total_dollar),
          moyen: this.selected_receive.symbol,
          id: id,
          status: 'attente',
          network,
          phone_number: this.phone_number,
          address: this.receive_wallet,
          type: 'momopay',
          created_at: firebase.firestore.FieldValue.serverTimestamp(),
          user_id: user_id,
          real_give_amount: Number(real_give_amount),
          fee,
          cameroun_citizen,
          otp: this.otp,
          hiropay_pay_fee: this.hiropay_pay_fee,
          momo_fee: this.selected_give.fee,
        }

        let request_headers = await this.get_headers(data)

        if (this.selected_give.title == 'OM BURKINA' && this.otp.toString().length !== 6 && this.processors.bf.buyProcessor == 'intouch') {
          alert('veuillez entrer un code OTP a 6 chiffres')
          return
        }

        if (this.selected_give.title == 'OM CIV' && this.otp.toString().length !== 4 && this.processors.ci.buyProcessor == 'intouch') {
          alert('veuillez entrer un code OTP a 4 chiffres')
          return
        }

        let base_url = this.base_url
        if (location.hostname === "localhost") {
          base_url = 'http://localhost:4000'
        }

        //base_url = 'http://170.187.187.204'

        //const axios_instance = axios.defaults.withCredentials = true

        let url = `${base_url}/external/momopay`

        console.log(url);
        const loading = this.$vs.loading()
        axios.post(url, {}, request_headers).then(async (result) => {
          loading.close()
          this.confirm_dialog = false
          this.receive_wallet = ''
          this.give_amount = 0
          this.phone_number = ''
          let { data } = result
          if (data.payment_url) {
            window.open(data.payment_url, '_blank', 'noopener,noreferrer');
            swal('depot en cours', 'Veuillez scanner le code QR sur la page ouvert pour payer', "success", { button: "ok" });
            return
          }
          let message
          let type
          let title
          switch (data) {
            case 'success': title = 'Paiement initié'; message = 'Veuillez confirmer sur votre telephone'; type = 'success'
              break;
            case 'error': title = 'Oups!! Paiement echoué'; message = 'Erreur veuillez verifier vos données et reessayer'; type = 'error'
              break;
            case 'otp invalid': title = 'Oups!! OTP invalide'; message = 'Veuillez entrer un code OTP valid'; type = 'error'
              break;
            default:
              break;
          }
          if (data == 'success' && this.selected_give.title == 'MOOV TOGO') {
            this.momopay_flooz_alert = true

            setTimeout(() => {
              this.momopay_flooz_alert = false
            }, 60000);
          }


          data == 'success' && ["OM MALI", "MOOV BURKINA"].includes(this.selected_give.title) ? this.paymentInstructionAlert = true : swal(title, message, type, { button: "ok" });

          console.log(result.data);

        }).catch((error) => {
          console.log(error.message);
          loading.close()
        })

        setTimeout(() => {
          loading.close()
        }, 10000);

      } else {
        alert('numero de telephone invalide')
      }
    },

    valid_phone_number(payload) {
      let { number, moyen } = payload;
      moyen = moyen.toLowerCase();
      let expectedNumberLength = 0
      if (['togo', 'tm', 'flooz', 'bf', 'burkina', 'mali', 'ml'].some(word => moyen.includes(word))) {
        expectedNumberLength = 8;
      } else if (['sn', 'senegal'].some(word => moyen.includes(word))) {
        expectedNumberLength = 9;
      } else if (['bj', 'benin', 'ci', 'civ', 'cote'].some(word => moyen.includes(word))) {
        expectedNumberLength = 10;
      }
      let numberValid = number.toString().length == expectedNumberLength ? true : false;
      this.valid_momo_number = numberValid
      this.valid_number = numberValid
      this.expectedNumberLength = expectedNumberLength
    },

    handle_sheet(moyen) {
      this.moyen = moyen
      this.sheet = false
    },
    async generate() {
      console.log('hello');
      let user = firebase.auth().currentUser;
      let asset = this.selected_give.currency
      
      //let currency = this.selected_give.network ? `${asset}.${give_network}` : asset
      let currency = asset
      console.log(currency);
      let sell_asset = asset.toLowerCase()
      let give_network = this.selected_give.network ? this.selected_give.network : ''
      let payload = {
        user_id: user.uid,
        amount: Number(this.receive_amount),
        moyen: this.moyen,
        currency: this.moyen,
        devise: 'cfa',
        type: 'vente',
        numero: this.numero,
        address: this.numero,
        currency_price_in_dollar: Number(this.currency_price_in_dollar),
        total_dollar: Number(this.total_dollar),
        give_amount: Number(this.give_amount),
        receive_amount: Number(this.receive_amount),
        give: this.selected_give.currency,
        sell_price: this.currencies.sell[sell_asset],
        deposit_address: '',
        give_network,
        name: '',
        instant_type: 'external',
        status: 'attente',
      }

      let base_url = this.base_url
      if (location.hostname === "localhost") {
        base_url = 'http://localhost:4000'
      }

      let coinpayment_url = `${base_url}/coinpayment/coinpayment_generate`
      let fiat_currency_url = `${base_url}/fiat_currencies/invoice`
      let fiat_currencies = ['PAYEER', 'ADV']
      let url = fiat_currencies.includes(this.selected_give.currency) ? fiat_currency_url : coinpayment_url
      const loading = this.$vs.loading()
      axios.post(url, {
        currency: currency,
        user_id: user.uid,
        type: 'external',
        network : give_network,
        payload
      }).then(async res => {
        loading.close()
        console.log(res.data);
        if (res.data.payment_url) {
          console.log('payment url');
          window.open(res.data.payment_url)
          return
        }

        let { address } = res.data
        this.deposit_address = address
        this.show_qr = true

      }).catch(e => {
        console.log(e);
        loading.close()
        alert('veuillez reessayer')
      })

    },

    go_back() {
      this.confirm_dialog = false;
      this.active = true
      this.show_qr = false
      this.deposit_address = ''
      this.pin = ''
      this.pin2faCode = ''
      this.expectedNumberLength = 0
      this.valid_momo_number = false
      this.phone_number = ''
      this.numero = ''
    },

    copy(address) {
      copy(address)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 10000);
    },

    valid_address() {
      const pm_regex = /^[U][0-9]{8}$/;
      const btc_regex = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;
      const eth_regex = /^0x[a-fA-F0-9]{40}$/;
      const trc_regex = /^T[a-zA-Z0-9]{20,45}$/;
      const payeer_regex = /^P[0-9]{8,11}$/;
      const adv_regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const sol_regex = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
      const eth_bsc_networks = ['ERC20', 'BSC(BEP20)'];

      // Determine validity based on the network or currency
      if (eth_bsc_networks.includes(this.network)) {
        this.valid_wallet = eth_regex.test(this.receive_wallet);
      } else if (this.network === 'TRC20') {
        this.valid_wallet = trc_regex.test(this.receive_wallet);
      } else {
        switch (this.selected_receive.currency) {
          case 'BTC':
            this.valid_wallet = btc_regex.test(this.receive_wallet);
            break;
          case 'PM':
            this.valid_wallet = pm_regex.test(this.receive_wallet);
            break;
          case 'TRX':
            this.valid_wallet = trc_regex.test(this.receive_wallet);
            break;
          case 'PAYEER':
            this.valid_wallet = payeer_regex.test(this.receive_wallet);
            break;
          case 'ADV':
            this.valid_wallet = adv_regex.test(this.receive_wallet);
            break;
          case 'SOL':
            this.valid_wallet = sol_regex.test(this.receive_wallet);
            break;
          default:
            this.valid_wallet = false;
        }
      }
    },


    async binance_balance() {
      try {
        let baseurl = this.base_url
        if (location.hostname === "localhost") {
          baseurl = 'http://localhost:4000'
        }
        let auth_token = await this.firebase_auth_token()
        let url = baseurl + '/payment/balances'
        console.log(url);
        let post_data = {
          "asset": "binance"
        }

        let { data, headers: { x_token } } = await axios.post(url, post_data, auth_token)

        let balance = await this.decode({
          token: x_token, ...data
        })

        console.log('binance', balance);

        let asset_details = {
          USDT: 2,
          BNB: 4,
          SHIB: 0,
          TRX: 2,
          SOL: 4
        }

        let base_assets = ['USDT', 'BNB', 'SHIB', 'TRX', 'SOL']

        base_assets.forEach(async element => {
          let asset_balance = balance[element].toFixed(asset_details[element])
          this.asset_reserve[element] = asset_balance > 0 ? asset_balance : 0
        })
      } catch (error) {
        console.log('binance_balance  error ', error);
      }

    },




    handle_give_box() {

      this.dialog_give_receive = true
      this.give = true
    },

    handle_selected_give(item) {

      this.dialog_give_receive = false
      this.selected_give = item

      let selectedGiveCurrency = this.selected_give.currency
      let selectedReceiveCurrency = this.selected_receive.currency

      let crypto_assets = ['BTC', 'SHIB', 'BNB', 'SOL', 'PAYEER', 'TRX', 'USDT', 'ADV', 'TON', 'HMTR', 'USD'];
      if (crypto_assets.includes(selectedGiveCurrency) && crypto_assets.includes(selectedReceiveCurrency)) {
        this.selected_receive = ''
      }

      if (crypto_assets.includes(item.currency)) {
        this.selected_receive = { id: 0, title: "CFA", img: "/img/cfa.png", symbol: 'CFA', decimal: 0, currency: 'CFA' }

      }

      let get_price_assets = ['HRP BTC', 'BNB', 'SHIB', 'DOGE', 'SOL', 'BTC', 'TON', 'HMTR', 'ETH', 'TRX']
      if (get_price_assets.indexOf(item.currency) >= 0) {
        this.get_currency_price(item.currency)
      }

      this.give_amount = ''
      this.receive_amount = ''
    },
    handle_receive_box() {
      this.dialog_give_receive = true
      this.require_network = false
      this.give = false
      this.binance_balance()
    },

    handle_selected_receive(item) {
      this.dialog_give_receive = false
      this.selected_receive = item
      //this.selected_give = this.give_assets[0]
      this.receive_amount = 0
      this.give_amount = 0
      this.require_network = true
      this.receive_wallet = ''
      this.network = ''

      let selectedGiveCurrency = this.selected_give.currency
      let selectedReceiveCurrency = this.selected_receive.currency

      let crypto_assets = ['BTC', 'SHIB', 'BNB', 'SOL', 'TRX', 'USDT', 'PAYEER', 'ADV', 'TON', 'HMTR'];
      if (crypto_assets.includes(selectedGiveCurrency) && crypto_assets.includes(selectedReceiveCurrency)) {
        this.selected_give = ''
      }
      let get_price_assets = ['HRP BTC', 'BNB', 'SHIB', 'DOGE', 'SOL', 'BTC', 'TON', 'HMTR', 'ETH', 'TRX']

      if (get_price_assets.includes(item.currency)) {
        this.get_currency_price(this.selected_receive.currency)
      }
    },

    check_data() {
      if (this.selected_give && this.selected_receive) {
        this.deposit_address = ''
        this.show_qr = false

        //check if give different from receive
        if (this.selected_give.symbol == this.selected_receive.symbol) {
          return alert('echange non pris en charge')
        }
        //check give amount and receive amount
        if (Number(this.receive_amount) <= 0 || Number(this.give_amount) <= 0) {
          return alert('veuillez saisir le montant a recevoir ou a depenser')
        }

        //direct mobile money 
        //external
        if (this.receive_amount && this.give_amount && this.selected_give.type == 'external') {
          if (this.give_amount > 0 && this.receive_amount > 0 && this.numero && this.moyen && this.valid_number) {
            let min = 2000
            let max = 2000000
            if (this.receive_amount >= min && this.receive_amount <= max) {
              this.confirm_dialog = true;
              this.active = false
              return
            } else {
              return alert(`veuillez saisir un montant compris entre ${min} et ${max}`)
            }
          } else {
            return alert('veuillez remplir le numero, moyen de paiement, montant')
          }

        }

        //over reserve
        if (Number(this.receive_amount) > this.asset_reserve[this.selected_receive.currency]) {

          if (location.hostname !== "localhost") {
            this.over_reserve = true
            setTimeout(() => {
              this.over_reserve = false
            }, 2000);

            return
          }
        }
        //chck balance
        if (this.user[`${this.selected_give.name}Balance`] < Number(this.give_amount)) {
          this.active = false
          swal({
            title: "Erreur SOLDE",
            text: "solde insuffisant",
            icon: "error",
            timer: 2000
          })
          setTimeout(() => {
            this.active = true
          }, 2000);
          return
        }


        //instant change sell pm and btc from hiropay balance

        if (this.selected_receive.symbol == 'CFA' && this.receive_amount > 0 && this.selected_give.type == 'HIROPAY') {
          if (this.receive_amount < 2000) {
            return alert('retrait minimum est de 2000 fr')
          }

          if (this.give_amount > 0 && this.numero && this.moyen && this.valid_number) {
            this.confirm_dialog = true;
            this.active = false
          } else {
            return alert('veuillez remplir le numero, moyen de paiement, montant')
          }
          return
        } else {

          let receive = this.selected_receive
          let item = receive.currency.toLowerCase()
          if (this.selected_give.currency == 'HRP CFA' && this.user.cfaBalance < Number(this.give_amount) && this.selected_give.type == 'HIROPAY') {
            this.active = false
            swal({
              title: "Erreur SOLDE",
              text: "solde insuffisant",
              icon: "error",
              timer: 2000
            })
            setTimeout(() => {
              this.active = true
            }, 2000);
            return
          }

          let valid_data = (this.total_dollar / Number(this.currency_price_in_dollar)).toFixed(this.selected_receive.decimal) == Number(this.receive_amount).toFixed(this.selected_receive.decimal)
          console.log(valid_data, 'valid data');
          if (this.receive_amount && valid_data == true && this.currency_price_in_dollar > 0 && Number(this.receive_amount) > 0 && Number(this.give_amount) > 0) {
            let coin = this.currencies[`${item}`]
            let max = coin[`max_${item}`]
            let min = coin[`min_${item}`]
            if (this.receive_amount < min || this.receive_amount > max) {
              this.asset_selected_limit = { min, max }
              this.over_amount = true
              setTimeout(() => {
                this.over_amount = false
                this.asset_selected_limit = {}
              }, 2500);
              return
            }
            if (this.receive_wallet.length < 1) {
              this.require_wallet = true
              setTimeout(() => {
                this.require_wallet = false
              }, 2000);
              return
            }

            if (receive.currency == 'BTC' && this.receive_amount < 0.0001) {
              return
            }

            if (this.receive_amount && this.give_amount && this.valid_wallet) {
              let usdt_small_amount = this.selected_receive.currency == 'USDT' && this.selected_receive.network == 'TRC20' && this.receive_amount < 50
              usdt_small_amount ? this.usdt_small_amount_dialog = true : this.confirm_dialog = true;
              this.active = false
            }

          }
        }
      } else {
        console.log('devise non choisies');
        return alert('veuillez selectionner les devises a echanger')
      }
    },

    async submit() {
      let valid_data = () => {
        return (this.total_dollar / Number(this.currency_price_in_dollar)).toFixed(this.selected_receive.decimal) == Number(this.receive_amount).toFixed(this.selected_receive.decimal)
      }
      console.log((this.total_dollar / Number(this.currency_price_in_dollar)).toFixed(this.selected_receive.decimal) == Number(this.receive_amount).toFixed(this.selected_receive.decimal));
      if (valid_data() == true) {
        console.log("hello");
        let data = {
          give: this.selected_give.currency,
          receive: this.selected_receive.currency,
          give_amount: this.give_amount,
          receive_amount: this.receive_amount,
          receive_wallet: this.receive_wallet,
        }
        let peer = `${data.give}/${data.receive}`
        let doc_ref = db.collection('recent_transactions').doc()
        let user_id = this.user.id
        let item = this.selected_receive.currency.toLowerCase()

        let network
        this.selected_receive.network ? network = this.network : network = data.receive
        network == 'BSC(BEP20)' ? network = 'BSC' : ''
        network == 'TRC20' ? network = 'TRX' : ''
        let id = doc_ref.id

        let base_dollar_price = this.currencies[`${item}`][`$_${item}`]

        //check if is cameroun citzen

        let userCountry = this.userCountry
        let cameroun_citizen = userCountry == 'cm' ? true : false


        let data_set = {
          amount: Number(this.receive_amount),
          give_amount: Number(this.give_amount),
          receive_amount: Number(this.receive_amount),
          give: data.give,
          currency: data.receive,
          currency_price_in_dollar: Number(this.currency_price_in_dollar),
          currency_cfa_dollar: cameroun_citizen ? base_dollar_price + this.extra_cameroun : base_dollar_price,
          total_dollar: Number(this.total_dollar),
          moyen: this.selected_receive.symbol,
          id: id,
          "pass": this.pass,
          status: 'attente',
          cameroun_citizen,
          network,
          address: this.receive_wallet,
          commission: this.trade_commission * Number(this.total_dollar),
          type: 'achat',
          created_at: firebase.firestore.FieldValue.serverTimestamp(),
          user_id: user_id,
          token: this.pin2faCode
        }

        let post_set = {
          amount: Number(this.receive_amount),
          give_amount: Number(this.give_amount),
          receive_amount: Number(this.receive_amount),
          currency_price_in_dollar: Number(this.currency_price_in_dollar),
          //currency_cfa_dollar:this.currencies[`${item}`][`$_${item}`],
          moyen: this.selected_receive.symbol,
          id: id,
          status: 'attente',
          cameroun_citizen,
          network,
          address: this.receive_wallet,
          type: 'achat',

        }
        let baseurl = `${this.base_url}/external`
        if (location.hostname === "localhost") {
          baseurl = 'http://localhost:4000/external'
        }
        let url = `${baseurl}/solde_exchange`
        let request_headers = await this.get_headers(data_set)
        console.log(request_headers);
        if (Number(this.give_amount) > 0 && Number(this.receive_amount) >= 0) {
          axios.post(url, post_set, request_headers).then(result => {
            console.log(result.data);
            if (result.data == 'processing') {
              this.give_amount = 0
              this.receive_amount = 0
              this.receive_wallet = ''
              swal('success', 'ordre en cours', "success", { button: "ok" });
            } else {
              swal('error', 'erreur veuillez reessayer', "error", { button: "ok" });
            }

          }).catch(error => {
            swal({
              title: "Erreur",
              text: "erreur survenue veuillez reessayer",
              icon: "error",
            })

          })

        }

      }
    },

    auth_pin_error_notif() {
      this.confirm_dialog = false
      swal({
        title: "Erreur",
        text: "code incorrect",
        icon: "error",
        timer: 1000
      })

      setTimeout(() => {
        this.confirm_dialog = true
      }, 1000);
      return
    },


    async validateAuthPinCode() {

      const isValid = await this.valid_auth_pin(this.pin2faCode);

      if (isValid) {
        // Clear authentication codes
        if (this.selected_give.type === 'external') {
          // Generate deposit address for external transactions
          this.generate();
        } else {
          // Handle internal transactions
          const isSellingHiropayBalance = this.selected_receive.symbol === 'CFA';
          if (isSellingHiropayBalance) {
            this.dispatch_send_cfa();
          } else {
            this.submit();
          }
          this.confirm_dialog = false;
        }
      } else {
        // Notify about invalid PIN or 2FA code
        this.auth_pin_error_notif();
      }
    }
    ,


    async dispatch_send_cfa() {
      let deposit_doc = db.collection("recent_transactions").doc()
      let data_set = {
        id: deposit_doc.id,
        user_id: this.user.id,
        amount: Number(this.receive_amount),
        moyen: this.moyen,
        currency: this.moyen,
        devise: 'cfa',
        type: 'Retrait',
        give_amount: this.give_amount,
        commission: this.trade_commission * Number(this.total_dollar),
        receive_amount: this.receive_amount,
        give: this.selected_give.currency,
        numero: this.numero,
        sell_price: this.currencies.sell[this.selected_give.name],
        address: this.numero,
        asset: this.selected_give.name,
        status: 'attente',
        created_at: '',
        token: this.pin2faCode
      }
      let baseurl = `${this.base_url}/external`
      if (location.hostname === "localhost") {
        baseurl = 'http://localhost:4000/external'
      }
      let url = `${baseurl}/sell_currency`

      let request_headers = await this.get_headers(data_set)
      console.log(request_headers);

      let post_data = {
        id: deposit_doc.id,
        amount: Number(this.receive_amount),
        moyen: this.moyen,
        currency: this.moyen,
        devise: 'cfa',
        give_amount: this.give_amount,
        receive_amount: this.receive_amount,
        phone_number: this.numero,
        status: 'attente',
        created_at: '',
      }



      axios.post(url, post_data, request_headers).then(result => {
        console.log(result.data);
        if (result.data == 'processing') {
          swal('success', 'ordre en cours', "success", { button: "ok" });
          this.give_amount = 0
          this.receive_amount = 0
          this.numero = ''
        } else {
          swal('error', 'erreur veuillez reessayer', "error", { button: "ok" });
        }

      }).catch(error => {
        swal({
          title: "Erreur",
          text: "erreur survenue veuillez reessayer",
          icon: "error",
        })

      })

    },

    get_currency_price(asset) {

      if (asset !== 'USDT' && asset !== 'PM' && asset !== 'CFA') {
        console.log('get_currency', asset);
        axios.get(`https://api.binance.com/api/v3/avgPrice?symbol=${asset}USDT`).then(result => {
          let { price } = result.data
          console.log(price);
          let currency = asset.toLowerCase()
          console.log(currency);
          this[`${currency}_price`] = Number(price)
          console.log(this.btc_price, this.bnb_price, this.shib_price);
        })
      }
    },

    calculate_receive_amount() {
       let minimums = {
        btc: 20000,
        bnb: 100,
        shib: 0.00000787,
        ton: 1,
        hmtr: 0,
        usdt: 1,
        sol: 100,
        adv: 1,
        trx: 0.1,
        payeer: 1,
      };

      if (!this.selected_give || !this.selected_receive) {
        alert('Veuillez sélectionner les devises à échanger');
        return;
      }

      let giveCurrency = this.selected_give.currency;
      let receiveCurrency = this.selected_receive.currency;
      let crypto_assets = ['BTC', 'SHIB', 'BNB', 'SOL', 'TRX', 'USDT', 'PAYEER', 'ADV', 'TON', 'HMTR'];

      if (crypto_assets.includes(giveCurrency) && crypto_assets.includes(receiveCurrency)) {
        alert('cette operation n\'est pas autorisée');
        return
      }

      let usd_assets = ['PAYEER', 'ADV', 'USDT'];

      let give_amount = this.give_amount;

      // Vente d'actifs
      if (crypto_assets.includes(giveCurrency)) {
        let currency = giveCurrency.toLowerCase();
        console.log(currency);

        let sell_price = this.currencies.sell[currency];

        let price = usd_assets.includes(giveCurrency) ? 1 : this[`${currency}_price`];

        if (!sell_price || !price) {
          console.log('Pas de prix de vente disponible.');
          return;
        }

        console.log('Prix de vente', sell_price, 'Prix de la devise donnée en dollar', price);

        if (minimums[currency] !== undefined && price >= minimums[currency]) {
          let total_dollar = give_amount * price;
          this.receive_amount = (total_dollar * sell_price).toFixed(this.selected_receive.decimal);
          this.total_dollar = total_dollar;
          this.currency_price_in_dollar = price;
          console.log(total_dollar);
        }
        return;
      }

      // Achat d'actifs
      let receive_asset = this.selected_receive;
      let item = receiveCurrency.toLowerCase();

      let baseBuyPrice = this.currencies[item][`$_${item}`];


      if (!baseBuyPrice) {
        console.log(`Prix d'achat non disponible pour ${item}`);
        return;
      }

      let userCountry = this.userCountry
      console.log(this.user.country);
      console.log(userCountry);


      let buyPrice = userCountry === 'cm' ? baseBuyPrice + this.extra_cameroun : baseBuyPrice;

      console.log('Prix d\'achat ajusté :', buyPrice);

      if (this.direct_moyens.some(moyen => moyen.currency == giveCurrency)) {
        console.log('Paiement direct détecté');
        if (this.hiropay_pay_fee && this.selected_give.fee) {
          let fee = this.selected_give.fee;
          buyPrice += fee * buyPrice;
        }
      }

      let totalDollar = give_amount / buyPrice;
      this.total_dollar = totalDollar;
      console.log('Total en dollars :', totalDollar);

      if (crypto_assets.includes(receiveCurrency)) {
        let currency = receiveCurrency.toLowerCase();
        console.log(currency);

        let price = usd_assets.includes(receiveCurrency) ? 1 : this[`${currency}_price`];

        if (minimums[currency] !== undefined && price >= minimums[currency]) {
          this.receive_amount = (totalDollar / price).toFixed(receive_asset.decimal);
          this.currency_price_in_dollar = price;
        } else {
          console.log('Vérifiez la devise autorisée et le prix minimum.');
        }
      }
    }
    ,

    getCountry(search) {
      let method = search.toLowerCase()
      let words = method.split(' ')
      let word = words[1]
      function findListContainingWordPart(word) {
        const countryMap = {
          "ci": ["ci", "civ", "cote", "ivoire"],
          "tg": ["tg", "togo"],
          "ml": ["mali", "ml"],
          "bf": ["bf", "burkina", "faso"],
          "bj": ["bj", "benin"],
          "ng": ["ng", "niger"],
          "sn": ["sn", "senegal"],
          "cm": ["cm", "cameroun", "Cameroon"],
          "gb": ["gb", "gabon"],
          "cd": ["cd", "rdc"]
        };

        for (const [key, values] of Object.entries(countryMap)) {
          if (values.some(element => element.startsWith(word) || element.includes(word))) {
            return key;
          }
        }
        return null; // If no match is found
      }

      const country = findListContainingWordPart(word);
      console.log(country);
      return country;
    },

    calculate_give_amount() {
      
      let minimums = {
        btc: 20000,
        bnb: 100,
        shib: 0.00000787,
        ton: 1,
        hmtr: 0,
        usdt: 1,
        sol: 100,
        adv: 1,
        trx: 0.1,
        payeer: 1,
      };

      if (!this.selected_give || !this.selected_receive) {
        alert('Veuillez sélectionner les devises à échanger');
        return;
      }

      let crypto_assets = ['BTC', 'SHIB', 'BNB', 'SOL', 'TRX', 'USDT', 'PAYEER', 'ADV', 'TON', 'HMTR'];
      let usd_assets = ['PAYEER', 'ADV', 'USDT'];
      let receive_amount = this.receive_amount;
      let giveCurrency = this.selected_give.currency;
      let receiveCurrency = this.selected_receive.currency;
      
      if (crypto_assets.includes(giveCurrency) && crypto_assets.includes(receiveCurrency)) {
        alert('cette operation n\'est pas autorisée');
        return
      }

      // Vente d'actifs
      if (crypto_assets.includes(giveCurrency)) {
        let assetData = this.instant_data.prices
      console.log('give amount');
      
      console.log(assetData, 'assetData');
        let currency = giveCurrency.toLowerCase();
        let sell_price = this.currencies.sell[currency];
        let price = usd_assets.includes(giveCurrency) ? 1 : this[`${currency}_price`];

        if (!sell_price || !price) {
          console.log('Pas de prix de vente disponible.');
          return;
        }

        console.log('Prix de vente', sell_price, 'Prix de la devise donnée', price);

        if (minimums[currency] !== undefined && price >= minimums[currency]) {
          let total_dollar = receive_amount / sell_price;
          console.log(total_dollar);
          this.give_amount = (total_dollar / price).toFixed(this.selected_give.decimal);
          this.total_dollar = total_dollar;
          this.currency_price_in_dollar = price;
        }
        return;
      }

      // Achat d'actifs
      let receive_asset = this.selected_receive;
      let give_asset = this.selected_give;
      let item = receive_asset.currency.toLowerCase();
      let baseBuyPrice = this.currencies[item][`$_${item}`];

      if (!baseBuyPrice) {
        console.log(`Prix d'achat non disponible pour ${item}`);
        return;
      }
      let userCountry = this.userCountry
      console.log(userCountry);

      let buyPrice = userCountry === 'cm' ? baseBuyPrice + this.extra_cameroun : baseBuyPrice;

      if (this.direct_moyens.some(moyen => moyen.currency === giveCurrency)) {
        console.log('Mode de paiement direct détecté');

        if (this.hiropay_pay_fee && this.selected_give.fee) {
          let fee = this.selected_give.fee;
          buyPrice += fee * buyPrice;
        }
      }
      console.log(buyPrice, receiveCurrency);
      if (crypto_assets.includes(receiveCurrency)) {
        let currency = receive_asset.currency.toLowerCase();
        console.log(currency);

        let price = usd_assets.includes(receive_asset.currency) ? 1 : this[`${currency}_price`];

        if (minimums[currency] !== undefined && price >= minimums[currency]) {
          let total_dollar = price * receive_amount;
          this.give_amount = (buyPrice * total_dollar).toFixed(give_asset.decimal);
          this.total_dollar = total_dollar;
          console.log(total_dollar);
          this.currency_price_in_dollar = price;
        } else {
          console.log('Vérifiez la devise autorisée et le prix minimum.');
        }
      }
    }
    ,

    handle_receive_focus() {
      this.receive_focus = true,
        this.give_focus = false
    },

    handle_give_focus() {
      this.receive_focus = false,
        this.give_focus = true
    },
    ...mapActions('authfb', ['bind_instant']),
    ...mapActions('authfb', ['bind_perso']),
  },
};
</script>

<style lang="scss" scoped>
input.input_data {
  font-size: 1.7em;
  padding: 5px;
}

div.give-box {
  border: 2px solid black;
  border-radius: 5px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 60px;

}

input[placeholder="montant"] {
  font-weight: 900;
}

input.input_wallet {
  border: 1px solid black;
  width: 300px;
  height: 30px;
  border-radius: 4px;
}

div.giv_back_box {
  border: 2px solid white;

}

div.coin_back_box {
  border: 0.5px solid grey;
  border-radius: 5px;
  cursor: pointer;
}

div.back_title {
  border: 1px solid white;
}



div.coin-box,
div.coin_back_box {
  display: flex;
  text-align: center;
  background-color: #F4F4F4;
  justify-content: center;
  align-items: center;
  height: 60px;
  cursor: pointer;
}

div.coin-box {
  border: 1px solid black;
}


div.coin_back_box {
  border: 2px solid black;
}

/* This container is needed to position the front and back side */
.exchange-section {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;

}

/* Do an horizontal flip when you move the mouse over the flip box container */

/* Style the front side */
.flip-box-front {

  color: black;
}

/* Style the back side */
.flip-box-back {
  background-color: #F4F4F4;
  color: black;

}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>